export default __webpack_public_path__ + "static/media/new-ci-front-ejemplo.3b9c8a93.jpg";